import React, { Component } from "react";
import { connect } from "react-redux";
import M from "materialize-css/dist/js/materialize.min.js";
import $ from "jquery";
import { Link } from "react-router-dom";
import noUiSlider from "nouislider";
import { updateConnection,stopConnection,setLoading } from "../../actions/ui/settings";
import { settings,colors } from "../../config.js";
import Modal from "../helper/modal";
import callBC from "../../actions/helpers/bc";
import isElectron from 'is-electron';
import './wifi.css';
const ipcRenderer = window.ipcRenderer;

class Status extends Component {
  state = {...this.props.settings,searching:false,allowManual:false,view:'automatic'};
  componentDidMount() {
    let _this = this;
    setTimeout(() => {
      if ((_this.props.socket.connected === false) && isElectron()) _this.saveAuto();
    }, 2000);
  }
  saveAuto(){
    this.props.stopConnection()
    let settings = this.state;
    this.setState({searching:true});
    if(isElectron()){
      this.props.setLoading('automatic');
      ipcRenderer.send('discover');
      ipcRenderer.once('data', (e, data) => {
        let [hostname,port] = data.split(':');
        console.log({hostname,port})
        hostname = `http://${hostname}`;
        settings.hostname = hostname;
        settings.port = port;
        settings.scookie = 'scookie';
        settings.autoConnect = true;
        settings.manualConnect = false;
        this.updateSettings(settings,true)
      });
    }
    else {
      this.setState({searching:false});
      M.toast({
        html: "Cannot Automatically Connect in Browser",
        classes: "red",
        displayLength: 3000
      });
    }
  }
  async stop(){
    this.props.stopConnection()
  }
  async saveModal() {
    let settings = this.state;
    let _this = this;
    this.props.networksettings.forEach(({ id }) => {
      settings[id] = $(`#${id}`)[0].value.trim();
    });
    if (settings.hostname.endsWith("/")) {
      settings.hostname = settings.hostname.substring(0,settings.hostname.length - 1);
    }
    if (settings.hostname.includes("https") && settings.scookie.length === 0) {
      M.toast({
        html: "Secure Cookie must be set for HTTPS URL",
        classes: "red",
        displayLength: 3000
      });
    } else {
      settings.autoConnect = false;
      settings.manualConnect = true;
      this.props.setLoading(true);
      this.updateSettings(settings)
    }
  }
  updateSettings(settings,isAuto){
    let _this = this;
    var instance = M.Modal.getInstance(document.querySelectorAll("#modalSettings2")[0]);
    console.log('call on data')
    callBC(settings, "getSyncStatus", []).then(data => {
      console.log({data})
      if(data && data.result && data.result.status && data.result.status === 'complete'){
        callBC(settings, "getLatestBlock", []).then(data => {
            console.log({data})
            if(data && (Date.now() - data.result.timestamp*1000) < 60000){
              console.log('within it');
              _this.setState({searching:false});
              _this.props.updateConnection(settings, () => {});
              if(!isAuto) _this.setState({allowManual:false})
              if(instance.isOpen){
                this.props.setLoading(false);
                M.toast({
                  html: "Successfully Connected",
                  classes: "green",
                  displayLength: 3000
                });
              }
            }
            else if(isAuto) {
              _this.saveAuto()
            }
            else {
              this.props.setLoading(false);
              if(instance.isOpen){
                M.toast({
                  html: "Miner URL Incorrect",
                  classes: "red",
                  displayLength: 3000
                });
              }
            }
        }).catch(err => {
          if(isAuto) _this.saveAuto()
          else {
            this.props.setLoading(false);
            if(instance.isOpen){
              M.toast({
                html: "Miner URL Incorrect",
                classes: "red",
                displayLength: 3000
              });
            }
          }
        });
      }
      else {
        if(isAuto) _this.saveAuto()
        else {
          if(instance.isOpen){
            this.props.setLoading(false);
            M.toast({
              html: "Miner URL Incorrect",
              classes: "red",
              displayLength: 3000
            });
          }
        }
      }
    }).catch(err => {
      if(isAuto) _this.saveAuto()
      else {
        _this.props.updateConnection(settings, () => {});
        this.props.setLoading(false);
        if(instance.isOpen){
          M.toast({
            html: "Miner URL Incorrect",
            classes: "red",
            displayLength: 3000
          });
        }
      }
    });
  }
  renderModal() {
    let component = this.network();

    let buttonAction = null;
    let buttonText = null;
    if(!this.state.searching){
      if(this.state.view === 'automatic'){
        if(!this.props.settings.autoConnect){
          buttonAction = this.saveAuto.bind(this);
          buttonText = 'Use Automatic Connection';
        }
        else {
          buttonAction = this.stop.bind(this);
          buttonText = 'Stop Connection';
        }
      }
      if(this.state.view === 'manual'){
        if((!this.props.settings.manualConnect || this.state.allowManual || this.props.socket.no_rpc)) {
          buttonAction = this.saveModal.bind(this);
          buttonText = 'Use Manual Connection';
        }
        else {
          buttonAction = this.stop.bind(this);
          buttonText = 'Stop Connection';
        }
      }
    }

    return (
      <Modal
        id="modalSettings2"
        classes="modal modalOrders black-text"
        title="Connection Settings"
        buttonAction={buttonAction}
        buttonText={buttonText}
        noClose={true}
        style={{maxWidth:'500px'}}
        component={component}
      />
    );
  }
  check() {
    return (
      <i style={{color:colors.green,fontSize:'45px'}} className="material-icons icon" >
        check
      </i>
    )
  }
  searching(){
    return (
        <p style={{marginBottom:'50px',marginTop:'50px',textAlign:'center',fontSize:'15px',lineHeight:'20px',fontFamily:'monospace'}}>Searching for waypoints...</p>
    )
  }
  onChange(){
    this.setState({allowManual: true})
  }
  setview(view){
    this.setState({view})
  }
  automatic(){
    let display = this.state.view === "automatic" ? '' : 'none';

    return (
      <div className='col s12' style={{display}}>
        {this.state.searching ? this.searching():
          <p className='description'>This option allows you to <b>automatically connect</b> to any waypoint on the Block Collider network in order to <b>retrieve market data</b> and <b>relay your transactions</b>.</p>
        }
      </div>
    )
  }
  // borderTop:i != 0 ? '1px solid #80808080' : ''
  manual(){
    let settings = this.props.networksettings;
    let items = settings.map(({placeholder, title, id, max, min, background }, i) => {
      return (
        <div key={i} className="row mi" style={{marginLeft:'0'}}>
          <h6 style={{margin:'10px 0px', fontSize: "0.8rem", float: "left", lineHeight: "30px",color:'grey' }}>
            <b>{title}</b>
          </h6>
          <input placeholder={placeholder} onChange={this.onChange.bind(this)} id={id} type={max ? "number" : "text"} min={min} max={max} className="black-text" style={{borderBottom:'0',width:'50%',float: "right",marginTop: "5px",fontFamily: "Gilmer-Light", letterSpacing: "0.5px"}}/>
        </div>
      );
    });
    let display = this.state.view === "manual" ? '' : 'none';

    return (
      <div className='col s12' style={{display}}>
        {items}
      </div>
    )
  }
  network() {


    let mnemStyle = this.state.view === "manual" ? {color: "black"} : { color: "grey",borderBottom:'1px solid black', borderLeft:'1px solid black'};
    let jsonStyle = this.state.view === "automatic" ? {color: "black"} : { color: "grey",borderBottom:'1px solid black', borderRight:'1px solid black'};

    return (
      <div className="row mbd" id="network">
        <div className="col s6" style={{...jsonStyle,cursor:'pointer',padding:0}}>
          <h5 className='padding5' onClick={this.setview.bind(this, "automatic")} style={{fontSize:'1.3rem',textAlign:'center'}}>
            automatic
          </h5>
        </div>
        <div className="col s6" style={{...mnemStyle,cursor:'pointer',padding:0}}>
          <h5 className='padding5' onClick={this.setview.bind(this, "manual")} style={{fontSize:'1.3rem',textAlign:'center'}}>
            manual
          </h5>
        </div>
        {this.automatic()}
        {this.manual()}
      </div>
    );
  }
  openModal() {
    let _this = this;
    if (document.querySelectorAll("#modalSettings2")[0]) {
      var instance = M.Modal.getInstance(document.querySelectorAll("#modalSettings2")[0]);
      if (instance) instance.open();
      if(_this.props.settings.manualConnect){
        setTimeout(() => {
          _this.props.networksettings.forEach(({ id }) => {
            $(`#${id}`)[0].value = _this.state[id];
          });
        }, 100);
      }
    }
  }
  render() {
    return (
      <div>
        {this.renderModal()}
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  let networksettings = [
    {
      title: "Miner URL",
      id: "hostname",
      width: "100%",
      placeholder:'http://localhost'
      // background: "#80808030"
    },
    { title: "Miner Port", id: "port", width: "100%",placeholder:'Optional' },
    {
      title: "Miner Secure Cookie",
      id: "scookie",
      width: "100%",
      placeholder:'Optional'
      // background: "#80808030"
    }
  ];

  return {
    socket: state.socket,
    settings: state.settings.settings,
    networksettings
  };
}

// <div className='col s12 center' style={{marginTop:'20px'}}>
  {/*!this.props.socket.no_rpc && !this.state.searching && this.props.settings.manualConnect && !this.state.allowManual && this.check()*/}
// </div>

export default connect(
  mapStateToProps,
  {
    updateConnection,
    stopConnection,
    setLoading
  }
)(Status);
